import React from "react";
import { TRMargenConcepto } from "./TRMargenConcepto";

export const TRMargen = ({ linea, data, guia }) => {
  // console.log(guia)
  return (
    <>
      <tr>
        <td className="sticky-row-mw-150  col-default grupo brd-l">
          {linea}
        </td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo brd-r"></td>

      </tr>
      <TRMargenConcepto
        linea={"Utilidad Bruta"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r"}
        data={data}
        prop={"utilidad_bruta"}
        concepto={"Utilidad bruta"}
        guia={guia}
        color={"menos"}
      />
      <TRMargenConcepto
        linea={"Gastos"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-dif"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-dif"}
        data={data}
        prop={"gasto_Departamento"}
        concepto={"Gastos"}
        guia={guia}
        color={"mas"}
      />
      <TRMargenConcepto
        linea={"Utilidad de Operación"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r"}
        data={data}
        prop={"utilidad_operacion"}
        concepto={"Utilidad Operacion"}
        guia={guia}
        color={"menos"}
      />
      <TRMargenConcepto
        linea={"Sueldos"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-sueldo"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-sueldo"}
        data={data}
        prop={"nomina"}
        operador=""
        formatoMoneda={true}
        concepto={"Sueldos"}
        guia={guia}
        color={"mas"}
      />
      <TRMargenConcepto
        linea={""}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-b brd-r bck-sueldo"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-b brd-r bck-sueldo"}
        data={data}
        prop={"porc_nomina"}
        concepto={"Porcentaje sueldos"}
        guia={guia}
        color={"mas"}
      />
      <tr style={{ height: "20px" }}></tr>
    </>
  );
};
